import "@common/jquery.ext";
import {global} from "@common/store";
import {util} from "@common/util";
import {CommonGnbContext} from "@components/context/common.gnb";
import {CommonAccountContext} from "@components/context/common.account";
import {SimpleMenuContext} from "@components/context/simple.menu";
import {TopButton} from "@components/top.button";

$(() => {
    // common context
    global.component.context.gnb = new CommonGnbContext();
    global.component.context.account = new CommonAccountContext();
    global.component.context.simple = new SimpleMenuContext();
    global.topButton = new TopButton();

    // content header, footer
    if ($(".content-header .content").isEmpty()) {
        $(".content-header").hide();
    }
    if ($(".content-footer .content").isEmpty()) {
        $(".content-footer").hide();
    }
    // search
    $(".card-search").each((index: number, element: any) => {
        const obj = $(element);
        obj.find(".card-header").click(() => {
            obj.toggleClass("on");
        });
    });

    if (util.isMobile()) {
        const setScreenSize = () => {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };
        $(window).on("resize", setScreenSize);
        setScreenSize();
    }
});
